/*

    * consts.ts
    Global functions and globally accessible consts

*/
// IDs of each wordpress category (must be changed if categories are changed)
class WordPressCategories {
}
WordPressCategories.publicationsCategory = 409620;
WordPressCategories.researchCategory = 409619;
WordPressCategories.peopleCategory = 409618;
WordPressCategories.majorProjectsCategory = 409621;
WordPressCategories.newsUpdatesCategory = 409622;
// URLs for each wordpress category for fetching inside service.ts
export class WordPressSources {
}
WordPressSources.publications = `https://eng-lcml-2022.sites.olt.ubc.ca/wp-json/wp/v2/posts?categories=${WordPressCategories.publicationsCategory}`;
WordPressSources.research = `https://eng-lcml-2022.sites.olt.ubc.ca/wp-json/wp/v2/posts?categories=${WordPressCategories.researchCategory}`;
WordPressSources.people = `https://eng-lcml-2022.sites.olt.ubc.ca/wp-json/wp/v2/posts?categories=${WordPressCategories.peopleCategory}`;
WordPressSources.majorProjects = `https://eng-lcml-2022.sites.olt.ubc.ca/wp-json/wp/v2/posts?categories=${WordPressCategories.majorProjectsCategory}`;
WordPressSources.newsUpdates = `https://eng-lcml-2022.sites.olt.ubc.ca/wp-json/wp/v2/posts?categories=${WordPressCategories.newsUpdatesCategory}`;
